import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 查询区域列表
export function getDictionary(groupCode) {
    return request({
        baseURL,
        url: '/sysDictionary/list',
        method: 'get',
        params: {
            columnName:'id',
            columnSortType:'desc',
            page:1,
            size:999,
            groupCode
        }
    })
}

// 新增设备
export function uploadFile(data) {
    let form = new FormData();
    form.append("file", data);
    return request({
        url: global.$config.api.base_url + '/jk/common-api/common/uploadFiles',
        method: 'post',
        data: form,
        headers: {
            // ignoreValidate: true,
            "Content-Type":"multipart/form-data"
        }
    })
}